<template>
  <v-row id="marketing-cloud-usage">
    <v-col cols="6" class="pt-6">
      <usage-card title="Email Usage" :usageValue="emailsUsage">
        <template #chart>
          <div class="marketing-usage-card">
            <account-usage-donut-chart
              :data="_usageChartData"
              :background-colors="_backgroundColors"
              :inner-label="`Usage ${emailsUsagePercentage}%`"
            />
          </div>
        </template>
      </usage-card>
    </v-col>
    <v-col cols="6" class="pt-6">
      <v-card outlined height="188px" class="pa-4 ">
        <v-row no-gutters>
          <v-col cols="12" lg="12" class="">
            <div class="heading">
              <div class="font--secondary body-2 font-weight-600 ">
                SMS Usage
              </div>
              <div class="body-2">{{ smsUsage }}</div>
            </div>

            <div class="marketing-usage-chart pt-4">
              <sms-volume
                onlyChart
                :styles="barStyles"
                :recordDays="days"
                :fetchRecords="fetchSmsRecords"
              ></sms-volume>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import BarChart from "@core/components/charts/BarChart.vue";
import SmsVolume from "@core/components/widgets/SmsVolume.vue";
import UsageCard from "@core/views/self_service/usage/UsageCard.vue";

import UsageMixin from "@core/mixins/UsageMixin.js";
import AccountUsageDonutChart from "@core/views/self_service/usage/AccountUsageDonutChart.vue";

export default {
  name: "MarketingCloudUsage",
  mixins: [UsageMixin],
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    days: { type: Number, default: 0, required: true },
    smsUsageStats: {
      type: Object,
      default: () => ({ allocated: 0, used: 0 }),
      required: true
    },
    emailsUsageStats: {
      type: Object,
      default: () => ({ allocated: 0, used: 0 }),
      required: true
    }
  },
  watch: {
    days(val) {
      this.fetchSmsRecords = !this.fetchSmsRecords;
    }
  },
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: {
    BarChart,
    UsageCard,
    AccountUsageDonutChart,
    SmsVolume
  },
  /**
  |--------------------------------------------------
  | Computed Properties
  |--------------------------------------------------
  */
  computed: {
    barStyles() {
      let [height, width] = ["100px", "100%"];
      return { height, width };
    },
    emailsUsage() {
      return `${this.emailsUsageStats.used} of ${this.emailsUsageStats.allocated} emails`;
    },
    smsUsage() {
      return `${this.smsUsageStats.used} SMS messages sent & received`;
    },
    emailsUsagePercentage() {
      const { calculatePercentage } = this.$options.filters;

      const percent = calculatePercentage(
        this.emailsUsageStats.used,
        this.emailsUsageStats.allocated
      );

      return !isNaN(percent) ? Math.ceil(percent) : 0;
    }
  },
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    return {
      fetchSmsRecords: false,
      statsKey: "emailsUsageStats"
    };
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    intializeLegend() {}
  }
};
</script>
<style scoped>
  #marketing-cloud-usage {
    margin-top: 0px;
  }
</style>